module.exports = "/_next/static/images/54baa06a8c5a92349a38248ad6dcc8bc-bubble-gum-woman-square@lg-2x.jpg.webp";